import BankSyariahArthaLogo from "@/assets/images/landing_page/img-logo-bank-syariah-artha.png";
import BPRSGaidoIndonesiaLogo from "@/assets/images/landing_page/img-logo-bprs-gaido.png";

export const efundingSelectedProduct = [
    {
        id: 1, 
        title: 'Deposito Syariah Madani Premium',
        type: 'premium',
        initial_deposit: '100.000.000',
        description: 'Deposito Syariah Madani Premium adalah Deposito berjangka dengan sistem bagi hasil yang bersaing, akad mudharabah muthlaqah, aman dijamin LPS. Proses mudah, cepat dan pelayanan terbaik',
        duration: '6 Bulan',
        nisbah: '62:38',
        roi: '6.75%',
        icon: BankSyariahArthaLogo
    },
    {
        id: 2, 
        title: 'Deposito Syariah Madani Premium',
        type: 'premium',
        initial_deposit: '100.000.000',
        description: 'Deposito Syariah Madani Premium adalah Deposito berjangka dengan sistem bagi hasil yang bersaing, akad mudharabah muthlaqah, aman dijamin LPS. Proses mudah, cepat dan pelayanan terbaik',
        duration: '12 Bulan',
        nisbah: '71:29',
        roi: '6.75%',
        icon: BankSyariahArthaLogo
    },
    {
        id: 3, 
        title: 'Deposito Berkah Plus',
        type: 'berkah',
        initial_deposit: '50.000.000',
        description: 'Deposito Syariah Berkah Plus Jangka Waktu 3 Bulan Bebas Biaya Admin (Free Admin) dari BPRS Gaido Indonesia Cianjur - Jawa barat',
        duration: '3 Bulan',
        nisbah: '50:50',
        roi: '7.60%',
        icon: BPRSGaidoIndonesiaLogo
    },
    {
        id: 4, 
        title: 'Deposito Berkah Plus',
        type: 'berkah',
        initial_deposit: '50.000.000',
        description: 'Deposito Syariah Berkah Plus Jangka Waktu 3 Bulan Bebas Biaya Admin (Free Admin) dari BPRS Gaido Indonesia Cianjur - Jawa barat',
        duration: '3 Bulan',
        nisbah: '50:50',
        roi: '7.60%',
        icon: BPRSGaidoIndonesiaLogo
    },
    {
        id: 5, 
        title: 'Deposito Berkah Plus',
        type: 'berkah',
        initial_deposit: '50.000.000',
        description: 'Deposito Syariah Berkah Plus Jangka Waktu 3 Bulan Bebas Biaya Admin (Free Admin) dari BPRS Gaido Indonesia Cianjur - Jawa barat',
        duration: '3 Bulan',
        nisbah: '50:50',
        roi: '7.60%',
        icon: BPRSGaidoIndonesiaLogo
    },
    {
        id: 6, 
        title: 'Deposito Syariah Madani Premium',
        type: 'premium',
        initial_deposit: '100.000.000',
        description: 'Deposito Syariah Madani Premium adalah Deposito berjangka dengan sistem bagi hasil yang bersaing, akad mudharabah muthlaqah, aman dijamin LPS. Proses mudah, cepat dan pelayanan terbaik',
        duration: '6 Bulan',
        nisbah: '62:38',
        roi: '6.75%',
        icon: BankSyariahArthaLogo
    },
    {
        id: 7, 
        title: 'Deposito Syariah Madani Premium',
        type: 'premium',
        initial_deposit: '100.000.000',
        description: 'Deposito Syariah Madani Premium adalah Deposito berjangka dengan sistem bagi hasil yang bersaing, akad mudharabah muthlaqah, aman dijamin LPS. Proses mudah, cepat dan pelayanan terbaik',
        duration: '12 Bulan',
        nisbah: '71:29',
        roi: '6.75%',
        icon: BankSyariahArthaLogo
    },
]


// WEBPACK FOOTER //
// ./src/utils/efunding_selected_product.js